var scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
  setTimeout(function () {
    loadScript("//www.naturespell.com/cdn/shop/t/6/assets/dynamic-reel-video-section.js?v=143830338466493366041764956461");
    loadScript("//www.naturespell.com/cdn/shop/t/6/assets/quantity-popover.js?v=987015268078116491764956458");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-card.css?v=120341546515895839841764956459");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-cart.css?v=164708765130180853531764956461");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-cart-items.css?v=13033300910818915211764956460");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-totals.css?v=15906652033866631521764956460");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-price.css?v=47596247576480123001764956460");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/component-discounts.css?v=152760482443307489271764956458");
    loadCSS("//www.naturespell.com/cdn/shop/t/6/assets/quantity-popover.css?v=160630540099520878331764956461");
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mousemove', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts({ type: 'initialScroll', isTrusted: true });
} else {
  document.addEventListener('scroll', loadScripts);
  document.addEventListener('mousemove', loadScripts);
  document.addEventListener('click', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}